<div class="tw-flex tw-justify-end tw-mr-2">
  <button type="button" mat-icon-button class="close" data-dismiss="modal"
    aria-label="Click to close this modal" (click)="dismiss()">
    <streamline-icon name="close" width="12" height="12"></streamline-icon>
  </button>
</div>
<h4 id="assign-users-label" class="tw-text-center">Assign Users</h4>
<mat-dialog-content>
  <div id="errorBox" [shown]="users.apiError" class="alert alert-danger text-danger" role="alert">
    <strong>{{users.errorMessage}}</strong> {{users.apiError}}
  </div>
  <!-- Search -->
  <search-filter [filterConfig]="filterConfig" [search]="search" [doSearch]="users.doSearch"></search-filter>
  <!-- List of Users -->
  <div class="scrollable-list u_margin-sm-top mb-2"
    scrollingList (scrollEndEvent)="users.load()"
    rvSpinner="company-users-list" [rvShowSpinner]="users.loadingItems">
    <table class="table">
      <thead class="table-header">
        <tr class="table-header__row">
          <th class="table-header__cell u_clickable">
            Username
          </th>
        </tr>
      </thead>
      <tbody class="table-body">
        @for (user of users.items.list; track user) {
          <tr class="table-body__row">
            <td class="table-body__cell flex-row u_clickable" [ngClass]="{ 'selected': userSelected(user.id) }" (click)="toggleUser(user.id)">
              <mat-checkbox class="mr-0" [ngModel]="userSelected(user.id)"></mat-checkbox>
              <p class="list-group-item-text"><strong>{{user.firstName}} {{user.lastName}}</strong><small class="text-muted ml-2">{{user.email}}</small></p>
            </td>
          </tr>
        }
        @if (!users.loadingItems && users.items.list.length === 0) {
          <tr class="table-body__row">
            <td class="table-body__cell">
              <p class="list-group-item-text">No assignable users</p>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button type="button" mat-stroked-button data-dismiss="modal" (click)="dismiss()">
    Cancel
  </button>
  <button type="button" mat-flat-button color="primary" (click)="apply()">
    Assign Users
  </button>
</mat-dialog-actions>
